if (!customElements.get('category-viewport')) {
  customElements.define('category-viewport', class CategoryViewport extends HTMLElement {
    index = 0

    constructor() {
      super()

      // elements
      this.button = this.querySelector('button.next-button')
      this.track = this.querySelector('.category-track')
      this.images = this.querySelectorAll('.category-image')

      // hide button larger screen if only three
      if(this.images.length <= 3)
        this.button.classList.add('xl:tw-hidden')
      
      // hide button on mobile
      if(window.innerWidth <= 768 && parseInt(this.dataset.categoryIndex) > 0)
        this.button.classList.add('tw-hidden')

      // listeners
      this.button.addEventListener('click', this.onSlide.bind(this))
      document.addEventListener('category-picker-change', this.checkVisibility.bind(this))
    }

    onSlide(event) {
      event.preventDefault()
      this.index++
      if(this.index == this.images.length) this.index = 0
      // DD: Hack: Adding 10 for the 1rem gap between images
      this.track.style.marginLeft = `-${this.index * (this.images[0].clientWidth + 10)}px`
    }

    checkVisibility(event) {
      if (event.detail.number === parseInt(this.dataset.categoryIndex))
        this.button.classList.remove('tw-hidden')
      else
        this.button.classList.add('tw-hidden')
    }
  })
}